export const getInitialsForName = (name: string): string => {
  return (
    name
      .split(/[\s|-]+/g)
      .map((partial) => (partial ?? '').substring(0, 1))
      .filter(Boolean)
      .slice(0, 2)
      .join('') || '?'
  ).toUpperCase()
}
